Page goodsPage
	title = "Fahrzeuge"
	showFor = [Admin]
	needsAuth = true
	
	DatabaseTable<Good>	goods = {"goods"}
	
	show: string id = ""
		if not app.isLoggedIn then app.navigateTo loginPage; return
		html.setTitle title + app.titleSuffix
		await goods.subscribe
		print goods.length
		refresh

	tick
		if goods.length > 0 then refresh
	
	draw
		if app.user?.userType != Admin then return
		goods.items.orderByDescending.created
		row alignItems:center, justifyContent:spaceBetween, gap:16, margin:{8 0 8 0}
			column
				div "Fahrzeuge" color:secondaryColor fontSize:36
				row fontSize:15, color:lightGray, flexWrap:wrap, rowGap:0, columnGap:20
					div text:"<b>{goods.items.count.state == Guest or .state == Draft}</b> Entwürfe"
					div text:"<b>{goods.items.count.state == Review}</b> In Prüfung"
					div text:"<b>{goods.items.count.state == Auction}</b> Auktionen"
					div text:"<b>{goods.items.count.state == Negotiation}</b> Nachverhandlungen"
					div text:"<b>{goods.items.count.state == NotSold}</b> Nicht verkauft"
					div text:"<b>{goods.items.count.state == Sold}</b> Verkauft"
					div text:"<b>{goods.items.count.state == PickedUp}</b> Abgeholt"
		goods.items.orderByDescending.created
		column gap:style.gapBetweenBoxes
			for goods
				app.drawGoodBox ., isAdminPage:true
